import React, { createContext, useContext, useState, useCallback } from "react";
import axiosInstance from "../AxiosInstance";
import config from "../config/config";

const JobContext = createContext();

export const JobProvider = ({ children }) => {
  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);

  const fetchAllJobs = useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        `${config.API_BASE_URL}/v1/jobs`
      );
      let allJobs = response.data || [];
      allJobs.sort((a, b) => {
        const dateA = new Date(a.postedTime);
        const dateB = new Date(b.postedTime);
        return dateB - dateA;
      });
      setJobs(response.data || []);
      console.log("Fetched all jobs:", response.data);
    } catch (error) {
      console.error("Failed to fetch all jobs:", error);
    }
  }, []);

  const fetchJobById = useCallback(async (jobId) => {
    try {
      const response = await axiosInstance.get(
        `${config.API_BASE_URL}/v1/jobs/${jobId}`
      );
      setSelectedJob(response.data);
      console.log(`Fetched job with ID ${jobId}:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`Failed to fetch job by ID ${jobId}:`, error);
      return null;
    }
  }, []);

  const fetchJobsByClientId = useCallback(async (clientId) => {
    try {
      const response = await axiosInstance.get(
        `${config.API_BASE_URL}/v1/jobs`
      );
      const allJobs = response.data || [];
      const clientJobs = allJobs.filter((job) => job.clientId === clientId);
      clientJobs.sort(
        (a, b) => new Date(b.postedTime) - new Date(a.postedTime)
      );
      setJobs(clientJobs);

      console.log(`Fetched jobs for clientId ${clientId}:`, clientJobs);
    } catch (error) {
      console.error(`Failed to fetch jobs for clientId ${clientId}:`, error);
    }
  }, []);

  return (
    <JobContext.Provider
      value={{
        jobs,
        selectedJob,
        fetchAllJobs,
        fetchJobById,
        fetchJobsByClientId,
      }}
    >
      {children}
    </JobContext.Provider>
  );
};

export const useJob = () => useContext(JobContext);
